export const environment = {
  // api_root: "http://localhost:3230",
  // ws_root: "ws://localhost:3230",
  api_root: "https://stg-esim-system-service.sakuramobile.jp",
  ws_root: "wss://stg-esim-system-service.sakuramobile.jp",
  gmo_shop_id: '9100176413941'
};
